import type { Difficulty } from '../../game/generator';
import type { GeneratorRequest, GeneratorResponse } from '../../game/worker-protocol';

export type GeneratorWorker = {
  postMessage: (message: GeneratorRequest) => void;
  addEventListener: (
    type: 'message',
    listener: (event: MessageEvent<GeneratorResponse>) => void,
  ) => void;
  terminate: () => void;
};

export type GeneratorWorkerFactory = () => GeneratorWorker;

export type GeneratorClient = {
  generate: (
    difficulty: Difficulty,
    seed: number,
    onResult: (response: GeneratorResponse) => void,
  ) => void;
  dispose: () => void;
};

export function createGeneratorClient(createWorker: GeneratorWorkerFactory): GeneratorClient {
  let currentRequestId = 0;
  let currentCallback: ((response: GeneratorResponse) => void) | null = null;
  let activeWorker: GeneratorWorker | null = null;

  return {
    generate(difficulty, seed, onResult) {
      activeWorker?.terminate();
      currentRequestId += 1;
      currentCallback = onResult;
      const requestId = currentRequestId;
      const worker = createWorker();
      activeWorker = worker;
      worker.addEventListener('message', (event) => {
        if (event.data.requestId === currentRequestId && requestId === currentRequestId) {
          currentCallback?.(event.data);
        }
      });
      worker.postMessage({
        type: 'generate',
        requestId,
        difficulty,
        seed,
      });
    },
    dispose() {
      currentCallback = null;
      activeWorker?.terminate();
      activeWorker = null;
    },
  };
}
